<template>
  <!--对话框 获取员工列表-->
  <el-dialog
    :visible="isShow"
    :width="width"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    :append-to-body="true"
    :show-close="false"
  >
    <div slot="title" class="dialog-title-container">
      <span class="title-label"><i class="el-icon-s-goods"></i> 库位选择</span>
      <i class="el-icon-error" @click="close"></i>
    </div>
    <div v-if="query.category === '0'">
      <el-row>
        <el-col style="color:#333333;font-weight: bold;" :span="2"
          >类别：</el-col
        >
        <el-col style="color:#333333;font-weight: bold;" :span="3">资材</el-col>
      </el-row>
    </div>
    <div v-if="query.category === '1'">
      <el-row>
        <el-col style="color:#333333;font-weight: bold;" :span="2"
          >类别：</el-col
        >
        <el-col style="color:#333333;font-weight: bold;" :span="3">
          <el-select
            size="mini"
            v-model="query.code"
            @change="categoryChange"
            style="margin-top: -5px;"
          >
            <el-option
              v-for="item in categoryList"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>
    <div class="dialog-search-container">
      <el-input size="mini" placeholder="请输入库位" v-model="query.position">
        <template slot="prepend">搜索：</template>
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="searchHandler"
        ></el-button>
      </el-input>
    </div>
    <div class="dialog-main-container">
      <el-table
        :data="ds"
        size="mini"
        height="410px"
        style="width: 100%;"
        stripe
        border
        header-row-class-name="list-header-row"
        row-class-name="list-row"
      >
        <el-table-column
          label="类别"
          prop="category"
          align="center"
          width="350"
        ></el-table-column>
        <el-table-column
          label="库位"
          prop="position"
          align="center"
          width="350"
        ></el-table-column>
        <el-table-column
          label="选择"
          header-align="center"
          align="center"
          width="50"
        >
          <template slot-scope="scope">
            <el-button
              type="info"
              size="mini"
              icon="el-icon-check"
              circle
              plain
              @click.stop="checkPosition(scope.$index)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          background
          :current-page="query.pn"
          :page-size="query.pageSize"
          :total="query.totalCount"
          :page-sizes="[10, 15, 20, 25, 30, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChange"
          @current-change="pageChange"
        ></el-pagination>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "EzzDialogPosition",
  props: {
    parent: {
      type: Object,
      default: () => null
    },
    width: {
      type: String,
      default: "50%"
    }
  },
  data: function() {
    return {
      isShow: false,
      ds: [],
      query: {
        category: "0",
        code: "009",
        position: "",
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 1
      },
      storeId: "", //需要移库的库存id
      categoryList: [
        { key: "010", value: "二楼" },
        { key: "011", value: "三楼" },
        { key: "012", value: "全自动" }
      ]
    };
  },
  mounted: function() {},
  methods: {
    loadData: function() {
      let _this = this;
      _this.post(_this.$apis.getAvaliablePosition, _this.query, function(res) {
        let _json = res.data;
        _this.ds = _json.datalist;
        _this.query.totalCount = _json.totalCount;
      });
    },
    open: function(category, positionCategory, id) {
      this.query.category = category;
      //category是库存区分车间和资材，positionCategory是二楼三楼自动化，id是库存主键
      if (category === "0") {
        this.query.code = "009";
      } else {
        if (positionCategory === "二楼") {
          this.query.code = "010";
        } else if (positionCategory === "三楼") {
          this.query.code = "011";
        } else {
          this.query.code = "012";
        }
      }
      this.storeId = id;
      this.loadData();
      this.isShow = true;
    },
    close: function() {
      this.isShow = false;
    },
    categoryChange: function(value) {
      this.query.code = value;
      this.loadData();
    },
    checkPosition: function(index) {
      let _this = this;
      _this.post(
        _this.$apis.updateAvaliablePosition,
        { storeId: _this.storeId, newId: _this.ds[index].id },
        function(res) {
          let _json = res.data;
          if (_json.status === "ok") {
            _this.$message({
              message: "移库成功",
              type: "success"
            });
            _this.parent.loadData();
            _this.isShow = false;
          } else {
            _this.$message({
              message: "移库失败",
              type: "error"
            });
          }
        }
      );
    },
    // 搜索事件
    searchHandler: function() {
      this.query.pn = 1;
      this.loadData();
    },
    // 页码改变
    pageSizeChange: function(pageSize) {
      this.query.pn = 1;
      this.query.pageSize = pageSize;
      this.loadData();
    },
    pageChange: function(pn) {
      this.query.pn = pn;
      this.loadData();
    }
  }
};
</script>
